import { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import AnimatedLoginPage from './components/auth/AnimatedLoginPage';
import AdminPanel from './components/admin/AdminPanel';
import Dashboard from './components/user/Dashboard';
import MobileGeoPage from './components/MobileGeoPage';
import MobileFaceIdPage from './components/auth/MobileFaceIdPage';
import MobileLocationPage from './components/geolocation/MobileLocationPage';
import FirstLoginGeoGate from './components/geolocation/FirstLoginGeoGate';
import MobileBlocker from './components/MobileBlocker';
import PrivateRoute from './components/auth/PrivateRoute';
import ImpersonationBanner from './components/auth/Components/ImpersonationBanner';
import { NotificationHost, notify } from './components/notifications';

// Для отладки в консоли разработчика: notify.success('текст'), notify.clear()
if (process.env.NODE_ENV !== 'production') {
  (window as unknown as { notify: typeof notify }).notify = notify;
}

const App: React.FC = () => {
  return (
    <Router>
      <NotificationHost />
      <ImpersonationBanner />
      <Routes>
        {/* Мобильные страницы - БЕЗ блокировки */}
        <Route path="/mobile-geo" element={<MobileGeoPage />} />
        <Route path="/mobile-faceid" element={<MobileFaceIdPage />} />
        <Route path="/mobile-location" element={<MobileLocationPage />} />

        {/* Страница логина */}
        <Route path="/" element={<MobileBlocker><AnimatedLoginPage /></MobileBlocker>} />

        {/* Защищённые страницы на основе целевого рабочего интерфейса роли из БД */}
        <Route path="/admin" element={<MobileBlocker><PrivateRoute targetInterface="admin"><AdminPanel /></PrivateRoute></MobileBlocker>} />
        <Route path="/dashboard" element={<MobileBlocker><PrivateRoute targetInterface="dashboard"><FirstLoginGeoGate><Dashboard /></FirstLoginGeoGate></PrivateRoute></MobileBlocker>} />
      </Routes>
    </Router>
  );
};

export default App;